import router from '@/router'
import axios from 'axios'
import { useToast } from 'vue-toastification'

const toast = useToast()

// API
const http = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

http.interceptors.request.use(
  (config) => {
    const jwt = localStorage.getItem('__access')
    if (jwt) {
      config.headers.authorization = `Bearer ${jwt}`
      config.headers.__company_id = localStorage.getItem('__company')
    }

    return config
  },
  (error) => {
    console.log(`Erro: ${error}`)
  }
)

http.interceptors.response.use(
  (res) => {
    return res
  },
  (err) => {
    if (err.response && err.response.status === 401) {
      router.push({ name: 'login' })
    }

    return Promise.reject(err)
  }
)

const mail = axios.create({
  baseURL: process.env.VUE_APP_SENDER_SERVE,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

mail.interceptors.response.use(
  (res) => {
    return res
  },
  (err) => {
    if (err.response && err.response.status === 500) {
      toast('Algo deu errado ao disparar evento', {
        toastClassName: 'toast-warning'
      })
    }

    return Promise.reject(err)
  }
)

export { http, mail }
